import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  root: {
    minWidth: 220,
    padding: theme.spacing(1.5),
  },
  descriptionLabel: {
    marginBottom: theme.spacing(0.5),
  },
  descriptionContent: {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical' as const,
    overflow: 'hidden',
    marginBottom: theme.spacing(1),
  },
}));
